/**
 * DashboardSkeleton — Loading placeholder for the dashboard page.
 * Shows carousel area + content placeholders using mb-skeleton tokens.
 */
export function DashboardSkeleton() {
  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      background: 'var(--mb-black)',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    }}>
      {/* Logo skeleton */}
      <div style={{
        padding: 'var(--mb-space-4)',
        display: 'flex',
        justifyContent: 'center',
      }}>
        <div className="mb-skeleton" style={{ width: 120, height: 40, borderRadius: 'var(--mb-radius-md)' }} />
      </div>

      {/* Carousel skeleton */}
      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 'var(--mb-space-4)',
        padding: '0 var(--mb-space-6)',
      }}>
        {/* Main carousel card */}
        <div className="mb-skeleton" style={{
          width: '100%',
          maxWidth: 600,
          height: 320,
          borderRadius: 'var(--mb-radius-xl)',
        }} />

        {/* Dots */}
        <div style={{ display: 'flex', gap: 8 }}>
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="mb-skeleton" style={{
              width: i === 0 ? 24 : 8,
              height: 8,
              borderRadius: 'var(--mb-radius-full)',
            }} />
          ))}
        </div>
      </div>

      {/* Content area skeleton */}
      <div style={{
        padding: 'var(--mb-space-4)',
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--mb-space-3)',
      }}>
        <div className="mb-skeleton mb-skeleton-title" />
        <div className="mb-skeleton mb-skeleton-card" style={{ height: 80 }} />
        <div className="mb-skeleton mb-skeleton-text" style={{ width: '70%' }} />
      </div>
    </div>
  );
}
